import { STORELOCATORCOMPONENT } from './storelocator.component';
import { LOCATIONCOMPONENT } from './location.component';

export class HeadlineComponent {
  createHeadline(element, headline, type) {
    const headlineHtmlElement =
      STORELOCATORCOMPONENT.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-headline');
    const sectionHeadingHtmlElement = headlineHtmlElement.querySelector('div.sg-cw-section-heading');
    const sectionHeading = sectionHeadingHtmlElement
      ? sectionHeadingHtmlElement
      : this.createSectionHeading(element, headline, type);

    headlineHtmlElement.appendChild(sectionHeading);
  }

  createSectionHeading(element, headlineString, type) {
    const sectionHeading = document.createElement('div');
    const sectionHeadingContent = document.createElement('div');
    const sectionHeadingHeadline = document.createElement('h2');

    if (type === 'single') {
      const currenLocationData = LOCATIONCOMPONENT.getCurrentLocationData(element.id);

      headlineString = headlineString.replace('##CITY##', `${currenLocationData['city']}`);
      headlineString = headlineString.replace('##NAME##', `${currenLocationData['name']}`);
    }
    if (type === 'multi') {
      headlineString = headlineString.replace('##CITY##', element);
    }

    sectionHeading.className = 'sg-cw-section-heading';
    sectionHeadingContent.className = 'sg-cw-section-heading-content';
    sectionHeadingHeadline.className = 'sg-cw-section-heading-headline';
    sectionHeadingHeadline.textContent = headlineString;

    sectionHeadingContent.appendChild(sectionHeadingHeadline);
    sectionHeading.appendChild(sectionHeadingContent);

    return sectionHeading;
  }
}

export const HEADLINE = new HeadlineComponent();
